// extracted by mini-css-extract-plugin
export var bankidButton = "LoginDialogButtons-module--bankidButton--aggvD";
export var kundnrButton = "LoginDialogButtons-module--kundnrButton--EXyvd";